import request from '../unit/request'

//登录
export function login(data) {
    const { password, userName } = data

    return request({
        url: '/kirincs-store/api/store/user/login',
        method: 'get',
        params: {
            password,
            userName
        }
    })
}
//名字登陆
export function byNameLogin(data){
    const {password,userName} = data
    return request({
        url:'/kirincs-store/wx/employee/login/by/name',
        method:"get",
        params:{
            password,
            nameByLogin:userName
        }
    })
}
// 退出登录
export function logout() {
    return request({
        url: '/kirincs-store/api/store/user/logout',
        method: 'get',
    })
}
//获取用户信息
export function getuser(data) {
    const userName = data
    return request({
        url: '/printer/api/login/getUser',
        method: 'get',
        params: { userName }
    })
}

// 注册
export function register(data) {
    return request({
        url: '/kirincs-user/api/store/user/register',
        method: 'post',
        data: {
            username: data.username,
            password: data.password,
            phone: data.phone,
            nickname: data.nickname,
            tenantName: data.tenantName,
        }
    })
}
// 修改密码
export function setPassword(data) {
    return request({
        // url: '/kirincs-user/api/user/change/password',
        url: '/kirincs-store/api/employee/change/password',
        method: 'post',
        data
    })
}